
import {Later} from 'utils/timers'
import ReasoningItem from './reasoning-item.vue'
import uuidToItems from './research-defs'

export default {
  components: {
    ReasoningItem
  },
  props: {
    chatId: {type: String, required: true},
    reasoning: {type: Array, default: () => []},
    completed: {type: Boolean, required: true},
  },
  emits: ['end'],
  data() {
    const init_items = uuidToItems(this.chatId)
    return {
      later: new Later(5000),
      height: 'max-content',
      top: false,
      bottom: false,
      init_items, 
      items: [init_items[0]]
    }
  },
  watch: {
    completed() {
      if (this.completed) {
        this.finishLoading()
      }
    },
    'reasoning.length'(next, prev) {
      const diff = next - prev
      if (!diff) return
      this.later.abort()
      this.items = [...this.init_items, ...this.reasoning]
    },
  },
  beforeUnmount() {
    this.later.abort()
  },
  created(){
    if (this.completed) {
      this.items = [...this.init_items, ...this.reasoning]
    }
    else {
      const [, second_init] = this.init_items
      this.later.once(() => this.items.push(second_init))
    }
  },
  async mounted() {
    this.checkScrollPosition()
    this.scrollToEnd()
  },
  methods: {
    finishLoading(){
      this.$emit('end')
    },
    scrollToEnd(smooth = false){
      // timer can call this after unmount
      this.$refs.scroller?.scrollToEnd(smooth)
    },
    afterEnter(el){
      if (!document.body.contains(el) || this.completed) {
        return
      }
      this.scrollToEnd(true)
    },
    checkScrollPosition() {
      const scroller = this.$refs.scroller.getContent()
      const scroll_top = scroller.scrollTop
      const scroll_height = scroller.scrollHeight
      const client_height = scroller.clientHeight

      const scrollable = scroll_height > client_height 

      this.top = !scrollable || scroll_top === 0
      this.bottom = !scrollable || scroll_top + client_height >= scroll_height - 1
    },
  },
}
